import { render, staticRenderFns } from "./ControlBarToggleButton.vue?vue&type=template&id=45f4df28&scoped=true"
import script from "./ControlBarToggleButton.vue?vue&type=script&lang=js"
export * from "./ControlBarToggleButton.vue?vue&type=script&lang=js"
import style0 from "./ControlBarToggleButton.vue?vue&type=style&index=0&id=45f4df28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4df28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f4df28')) {
      api.createRecord('45f4df28', component.options)
    } else {
      api.reload('45f4df28', component.options)
    }
    module.hot.accept("./ControlBarToggleButton.vue?vue&type=template&id=45f4df28&scoped=true", function () {
      api.rerender('45f4df28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ControlBarToggleButton.vue"
export default component.exports